import { useRef, useCallback } from 'react';

export const useClickBlockerToScroll = (onClickUp, threshold = 5) => {

    const moved = useRef(false);

    const handleTouchStart = () => {
        moved.current = false;
    };

    const handleTouchMove = () => {
        moved.current = true;
    };

    const handleMouseDown = () => {
        moved.current = false;
    };

    const handleMouseMove = () => {
        moved.current = true;
    };

    return {
        handleTouchStart,
        handleTouchMove,
        handleMouseDown,
        handleMouseMove,
    };
};
